import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';
import type { ProjectFileKindEnum, ProjectFileVisibilityEnum } from '../generated/types';

export const PROJECT_FILES_QUERY = gql`
  query ProjectFiles($projectId: ID!, $fileType: ProjectFileKindEnum, $folder: String, $visibility: ProjectFileVisibilityEnum) {
    projectFiles(projectId: $projectId, fileType: $fileType, folder: $folder, visibility: $visibility) {
      id
      name
      description
      fileType
      category
      visibility
      folder
      version
      url
      contentType
      mediaType
      size
      uploadedBy {
        id
        fullName
      }
      uploadedAt
    }
  }
`;

export interface UseProjectFilesOptions {
  projectId: string;
  fileType?: ProjectFileKindEnum | null;
  folder?: string | null;
  visibility?: ProjectFileVisibilityEnum | null;
}

export function useProjectFiles({ projectId, fileType, folder, visibility }: UseProjectFilesOptions) {
  const { data, loading, error, refetch } = useQuery(PROJECT_FILES_QUERY, {
    variables: { projectId, fileType, folder, visibility },
    skip: !projectId,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: false,
  });

  const files = (data as { projectFiles?: unknown[] })?.projectFiles ?? [];
  const folders = [...new Set((files as { folder?: string }[]).map((f) => f.folder).filter(Boolean))] as string[];

  return { files, folders, loading, error, refetch };
}
